// extracted by mini-css-extract-plugin
module.exports = {"Horizonta":"JP_Horizonta__1cbGJ","MixProduct":"JP_MixProduct__cY7pk"};